import type { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class ArticleTags extends BaseComponent {
  hiddenTags: Nullable<HTMLElement>
  visibleTags: Nullable<HTMLElement>
  tags: HTMLElement[]
  extendButton: Nullable<HTMLElement>

  resizeObserver: ResizeObserver

  constructor() {
    super()

    this.visibleTags = this.querySelector('[data-visible-tags]')
    this.hiddenTags = this.querySelector('[data-collapsed-tags]')
    this.tags = [...this.querySelectorAll('[data-tag]')] as HTMLElement[]
    this.extendButton = this.querySelector(`[data-extend-button]`)

    this.resizeObserver = new ResizeObserver(this.handleContentResize)
    this.resizeObserver.observe(this)
  }

  connectedCallback(): void {
    document.fonts.ready.then(() => {
      this.update()
    })
  }

  disconnectedCallback(): void {
    this.resizeObserver.disconnect()
  }

  handleContentResize = (): void => {
    this.update()
  }

  updateTagsOffsets(): void {
    this.tags.forEach(tag => {
      tag.style.left = `${tag.offsetLeft}px`
      tag.style.top = `${tag.offsetTop}px`
    })
  }

  updateExtendButton(): void {
    if (!this.extendButton) {
      return
    }

    const hiddenTags = this.querySelectorAll('[tag-hidden]')
    const hasHiddenTags = hiddenTags.length > 0

    this.extendButton.classList.toggle('hidden', !hasHiddenTags)
  }

  updateCollapsedTags(): void {
    const collapsedTagsFragment = document.createDocumentFragment()

    this.tags.forEach((tag, index) => {
      const nextTab = this.tags[index + 1]

      if (!nextTab) {
        return
      }

      const nextTabBottomSide = nextTab.offsetTop + nextTab.offsetWidth
      const maxHeight = this.offsetHeight - tag.offsetHeight

      const isHidden = nextTabBottomSide > maxHeight

      if (isHidden) {
        const clone = tag.cloneNode(true)

        this.setTagVisible(clone, true)

        collapsedTagsFragment.appendChild(clone)
      }

      this.setTagVisible(tag, !isHidden)
    })

    this.hiddenTags?.element.replaceChildren(collapsedTagsFragment)
  }

  setTagVisible(tag: HTMLElement, isVisible: boolean): void {
    tag.toggleAttribute('tag-hidden', !isVisible)
  }

  update(): void {
    this.updateTagsOffsets()
    this.updateCollapsedTags()
    this.updateExtendButton()
  }
}

export default ArticleTags
